'use client'

/**
 * Auth Segment Error Boundary (Issue #11651)
 *
 * Thin per-segment delegate — all chrome and wiring (icon, heading, action
 * buttons, copy-to-clipboard error details, reporting side effect) is
 * owned by `RouteErrorBoundary`. Copy is in
 * `SEGMENT_BOUNDARY_COPY['auth']` in
 * `src/components/route-error-boundary.tsx`.
 */

import { RouteErrorBoundary } from '@/components/route-error-boundary'

interface ErrorBoundaryProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function AuthError(props: ErrorBoundaryProps) {
  return <RouteErrorBoundary segment="auth" {...props} />
}
